import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {GroupChatDataService} from './shared/services/group-chat-data.service';
import {ChatDataService} from './shared/services/chat-data.service';
import Echo from 'laravel-echo';
import {AuthService} from './shared/services/auth.service';
import {WebsocketService} from "./shared/services/websocket.service";
import {StorageService} from "./shared/services/storage.service";


@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  constructor(private router: Router,
              private websocketService: WebsocketService,
  ) {
    const user = StorageService.getItem('self');
    if (user && ['EMPLOYEE', 'ADMIN'].includes(user?.user_type)) {
      this.websocketService.connect();
    }

    // for scrollbar on top
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const contentContainer =
          document.querySelector('.mat-sidenav-content') || document.body;
        contentContainer.scrollTop = 0;
      }
    });
  }

  ngOnInit(): void {
  }
}
